module.exports = __webpack_public_path__ + "img/star-3.53063c16.svg";